var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snackbar__wrapper"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},_vm._l((_vm.snackbars),function(snackbar){return _c('snackbar',{key:snackbar.id,attrs:{"type":snackbar.type,"prop-obj":snackbar},on:{"closed":_vm.onSnackbarClosed}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }